import React from 'react';

export type TicketIconProps = {
  number?: number|string,
  onClick?: () => void,
}

export const TicketIcon = ({onClick, number}: TicketIconProps) => {
  const width = 23;
  const height = 15;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 65"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {/* Forme du ticket avec encoches centrées */}
      <path
        d="
          M10,0
          H90
          C91.1,0 92,0.9 92,2
          V25
          A5,5 0 0,1 92,35
          A5,5 0 0,1 92,45
          V63
          C92,64.1 91.1,65 90,65
          H10
          C8.9,65 8,64.1 8,63
          V45
          A5,5 0 0,0 8,35
          A5,5 0 0,0 8,25
          V2
          C8,0.9 8.9,0 10,0
          Z"
        fill="#0033ff"
        stroke="#000"
        strokeWidth="2"
      />

      {/* Rectangle avec contour blanc seulement */}
      <rect
        x="20"
        y="12"
        width="60"
        height="40"
        fill="#0033ff"
        stroke="white"
        strokeWidth="2"
        rx="6"
      />

      {/* Texte du numéro */}
      <text
        x="50"
        y="38"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="40"
        fill="#fff"
        fontFamily="Arial, sans-serif"
      >
        {number}
      </text>
    </svg>
  );
}
